export default __webpack_public_path__ + "static/media/arco-ameaca.b87c9b5e.webp";